export function getImageUrl(
  image: string | null | undefined,
  scale = 'image',
): string | null {
  if (!image) return null;
  if (image.includes('/@@images/')) return image;
  return `${image}/@@images/${scale}`;
}